import { IonPage } from '@ionic/react';
import Header from 'components/Header/Header';

const Home: React.FC = () => {
  return (
    <IonPage>
      <Header name="Home" />
    </IonPage>
  );
};

export default Home;
